import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "full-height full-width grouper-body-container min-height" }
const _hoisted_2 = { class: "full-width full-height grouper-body-splitter-container" }
const _hoisted_3 = {
  key: 0,
  class: "grouper-body-pane-container"
}
const _hoisted_4 = {
  key: 0,
  class: "iodine-border full-height min-height"
}
const _hoisted_5 = {
  key: 1,
  class: "full-height min-height"
}

import {computed, ref} from 'vue';
    import CodesPane from 'components/codes/CodesPane.vue';
    import ResourcesPane from 'components/resources/ResourcesPane.vue';
    import SearchPane from 'components/search/SearchPane.vue';
    import ReferencesPane from 'components/references/ReferencesPane.vue';
    import ReferencesEmbedded from 'components/references/ReferencesPaneCompact.vue';
    import { useLayoutStore, GrouperPane } from 'stores/layout-store';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperBodyFullscreen',
  setup(__props) {

const layoutStore = useLayoutStore();

    const noOfSplits = computed(() =>
        (layoutStore.isCodesSelected ? 1 : 0) +
        (layoutStore.isSearchSelected ? 1 : 0) +
        (layoutStore.isReferencesSelected ? 1 : 0) +
        (layoutStore.isResourcesSelected ? 1 : 0)
    )

    const splitterSize = ref(0)

    const splitterModel = computed({
        get() {
            return (layoutStore.isResourcesSelected ? 70 : 50);
        },
        set(newValue: number) {
            splitterSize.value = newValue;
        },
    });

    const firstSplitterSize = ref(0)
    const secondSplitterSize = ref(0)

    // Need to have a conversation with Laura and determine how this computed needs to be changed.
    const firstSplitterModel = computed({
        get() {
            return (50);
        },
        set(newValue: number) {
            firstSplitterSize.value = newValue;
        },
    });

    const secondSplitterModel = computed({
        get() {
            return (layoutStore.isResourcesSelected ? 70 : 50);
        },
        set(newValue: number) {
            secondSplitterSize.value = newValue;
        },
    });

return (_ctx: any,_cache: any) => {
  const _component_q_splitter = _resolveComponent("q-splitter")!
  const _component_q_slide_transition = _resolveComponent("q-slide-transition")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_slide_transition, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (noOfSplits.value === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (noOfSplits.value === 1 && _unref(layoutStore).getPaneOne !== _unref(GrouperPane).REFERENCES)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      (noOfSplits.value === 1 && _unref(layoutStore).getPaneOne === _unref(GrouperPane).CODES)
                        ? (_openBlock(), _createBlock(CodesPane, { key: 0 }))
                        : _createCommentVNode("", true),
                      (noOfSplits.value === 1 && _unref(layoutStore).getPaneOne === _unref(GrouperPane).SEARCH)
                        ? (_openBlock(), _createBlock(SearchPane, { key: 1 }))
                        : _createCommentVNode("", true),
                      (noOfSplits.value === 1 && _unref(layoutStore).getPaneOne === _unref(GrouperPane).RESOURCES)
                        ? (_openBlock(), _createBlock(ResourcesPane, { key: 2 }))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (noOfSplits.value === 1 && _unref(layoutStore).getPaneOne === _unref(GrouperPane).REFERENCES)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createVNode(ReferencesPane)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (noOfSplits.value === 2)
            ? (_openBlock(), _createBlock(_component_q_splitter, {
                key: 1,
                modelValue: splitterModel.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((splitterModel).value = $event)),
                class: "grouper-body-splitter",
                "separator-style": "width: 6px; background-color: #F0F6FA;",
                "before-class": "iodine-border",
                "after-class": "iodine-border"
              }, {
                before: _withCtx(() => [
                  (_unref(layoutStore).getPaneOne === _unref(GrouperPane).CODES)
                    ? (_openBlock(), _createBlock(CodesPane, { key: 0 }))
                    : _createCommentVNode("", true),
                  (_unref(layoutStore).getPaneOne === _unref(GrouperPane).SEARCH)
                    ? (_openBlock(), _createBlock(SearchPane, { key: 1 }))
                    : _createCommentVNode("", true),
                  (_unref(layoutStore).getPaneOne === _unref(GrouperPane).REFERENCES)
                    ? (_openBlock(), _createBlock(ReferencesEmbedded, { key: 2 }))
                    : _createCommentVNode("", true)
                ]),
                after: _withCtx(() => [
                  (_unref(layoutStore).getPaneTwo === _unref(GrouperPane).SEARCH)
                    ? (_openBlock(), _createBlock(SearchPane, { key: 0 }))
                    : _createCommentVNode("", true),
                  (_unref(layoutStore).getPaneTwo === _unref(GrouperPane).REFERENCES)
                    ? (_openBlock(), _createBlock(ReferencesEmbedded, { key: 1 }))
                    : _createCommentVNode("", true),
                  (_unref(layoutStore).getPaneTwo === _unref(GrouperPane).RESOURCES)
                    ? (_openBlock(), _createBlock(ResourcesPane, { key: 2 }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          (noOfSplits.value === 3)
            ? (_openBlock(), _createBlock(_component_q_splitter, {
                key: 2,
                modelValue: firstSplitterModel.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((firstSplitterModel).value = $event)),
                class: "grouper-body-splitter full-height",
                "separator-style": "width: 6px; background-color: #F0F6FA;",
                "before-class": "iodine-border"
              }, {
                before: _withCtx(() => [
                  (_unref(layoutStore).getPaneOne === _unref(GrouperPane).CODES)
                    ? (_openBlock(), _createBlock(CodesPane, { key: 0 }))
                    : _createCommentVNode("", true),
                  (_unref(layoutStore).getPaneOne === _unref(GrouperPane).SEARCH)
                    ? (_openBlock(), _createBlock(SearchPane, { key: 1 }))
                    : _createCommentVNode("", true)
                ]),
                after: _withCtx(() => [
                  _createVNode(_component_q_splitter, {
                    modelValue: secondSplitterModel.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((secondSplitterModel).value = $event)),
                    class: "grouper-body-splitter",
                    "separator-style": "width: 6px; background-color: #F0F6FA;",
                    "before-class": "iodine-border",
                    "after-class": "iodine-border"
                  }, {
                    before: _withCtx(() => [
                      (_unref(layoutStore).getPaneTwo === _unref(GrouperPane).SEARCH)
                        ? (_openBlock(), _createBlock(SearchPane, { key: 0 }))
                        : _createCommentVNode("", true),
                      (_unref(layoutStore).getPaneTwo === _unref(GrouperPane).REFERENCES)
                        ? (_openBlock(), _createBlock(ReferencesEmbedded, { key: 1 }))
                        : _createCommentVNode("", true)
                    ]),
                    after: _withCtx(() => [
                      (_unref(layoutStore).getPaneThree === _unref(GrouperPane).REFERENCES)
                        ? (_openBlock(), _createBlock(ReferencesEmbedded, { key: 0 }))
                        : _createCommentVNode("", true),
                      (_unref(layoutStore).getPaneThree === _unref(GrouperPane).RESOURCES)
                        ? (_openBlock(), _createBlock(ResourcesPane, { key: 1 }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["modelValue"]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    })
  ]))
}
}

})